/**
 * Nützliche Hilfsfunktionen für Datums.
 *
 * @author Andreas Wenger
 */


/**
 * Versucht ein Datum im Format "dd.mm.yyyy" aus dem gegebenen
 * String zu bauen. Fehlt die Monats- bzw. Jahres-Angabe, wird näheste passende Datum
 * zum gegebenen Referenzdatum verwendet, in der Zukunft oder Vergangenheit relativ
 * zum Referenzdatum, je nach direction-Einstellung
 * ("back", "forward" oder ohne Angabe (dann max. 3 Jahre in die Zukunft).
 * Akzeptiert wird auch "3112" (31.12., Jahr wie oben beschrieben),
 * "311216" und "31122016" (beides 31.12.2016).
 * Fehlt alles, ist der Tag ungültig oder ist das gesamte Datum ungültig,
 * wird "" zurückgegeben.
 */
export function buildGermanDate(input : string, referenceDate : Date, direction: string) : string {

	//gegebenen Tag, Monat und Jahr lesen
	let tag = NaN, monat = NaN, jahr = NaN;
	if (input != undefined) {
		let parts = input.split(".");
		//Format "d.", "d.m", "d.m." oder "d.m.y"
		if (parts.length == 2) {
			tag = +parts[0];
			monat = +parts[1];
		}
		else if (parts.length == 3) {
			tag = +parts[0];
			monat = +parts[1];
			if (parts[2].length > 0) jahr = +parts[2];
		}
		//Format "1"/"31", "3112", "311216" oder "31122016"?
		else if (parts.length == 1 && (parts[0].length == 1 || parts[0].length == 2)) {
			tag = +parts[0];
		}
		else if (parts.length == 1 && parts[0].length == 4) {
			tag = +parts[0].substr(0, 2);
			monat = +parts[0].substr(2, 2);
		}
		else if (parts.length == 1 && (parts[0].length == 6 || parts[0].length == 8)) {
			tag = +parts[0].substr(0, 2);
			monat = +parts[0].substr(2, 2);
			jahr = +parts[0].substr(4);
		}
	}

	//zweistelliges Jahr korrigieren
	if (jahr >= 0 && jahr < 100) {
		let j = jahr + 2000;
		let d = datum(tag, monat, j);
		if (direction == "back" && d > referenceDate)
			jahr = j - 100;
		else if (direction == "forward" && d < referenceDate)
			jahr = j + 100;
		else if (!direction && d > new Date(referenceDate.getFullYear() + 3,
				referenceDate.getMonth(), referenceDate.getDate())) //mehr als 3 Jahre in der Zukunft
			jahr = j - 100;
		else
			jahr = j;
	}

	//wenn der Tag nicht gegeben ist, gib "" zurück
	if (isNaN(tag) || tag == 0)
		return "";

	//ermittle fehlenden Monat (inkl. Jahr)
	if (isNaN(monat) || monat == 0) {
		if (direction == "back") { //Referenzdatum oder Vergangenheit
			monat = (referenceDate.getMonth() + 1) - (tag > referenceDate.getDate() ? 1 : 0);
			jahr = referenceDate.getFullYear();
			if (monat == 0) { //Springe in den Dezember des letzten Jahres
				monat = 12;
				jahr -= 1;
			}
		}
		else { //Referenzdatum oder Zukunft
			monat = (referenceDate.getMonth() + 1) + (tag < referenceDate.getDate() ? 1 : 0);
			jahr = referenceDate.getFullYear();
			if (monat == 13) { //Springe in den Dezember des letzten Jahreste
				monat = 1;
				jahr += 1;
			}
		}
	}

	//ermittle fehlendes Jahr
	if (isNaN(jahr) || jahr == 0) {
		if (direction == "back") { //Referenzdatum oder Vergangenheit
			let d = datum(tag, monat, referenceDate.getFullYear());
			jahr = referenceDate.getFullYear() - (d > referenceDate ? 1 : 0);
		}
		else { //Referenzdatum oder Zukunft
			let d = datum(tag, monat, referenceDate.getFullYear());
			jahr = referenceDate.getFullYear() + (d < referenceDate ? 1 : 0);
		}
	}

	//Teste Datum
	let checkDate = datum(tag, monat, jahr);
	if (checkDate.getDate() == tag && checkDate.getMonth() + 1 == monat && checkDate.getFullYear() == jahr) {
		//Datum passt. So zurückgeben.
		let sTag = tag.toString(); if (sTag.length == 1) sTag = "0" + sTag;
		let sMonat = monat.toString(); if (sMonat.length == 1) sMonat = "0" + sMonat;
		let sJahr = jahr.toString();
		return sTag + "." + sMonat + "." + sJahr;
	}
	else {
		//Ungültiges Datum (z.B. 32. Januar o.ä.)
		return "";
	}
}

/**
 * Erzeugt ein Date-Objekt. Tag: 1-31, Monat: 1-12, Jahr: z.B. 2012.
 */
export function datum(tag: number, monat: number, jahr: number) {
	return new Date(jahr, monat - 1, tag);
}


// WEBPACK FOOTER //
// ./src/util/date-utils.ts